/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
import DefaultPredicateComparisonOptions from 'predicates/models/data/default-predicate-comparison-options';
const CustomComparisonOptions = {
  custom: {
    'conversation.team_assignee_id': {
      optionalSelect: {
        comparison: [{
          label: 'is',
          value: 'eq'
        }, {
          label: 'is not',
          value: 'ne'
        }]
      }
    },
    'conversation.admin_assignee_id': {
      optionalSelect: {
        comparison: [{
          label: 'is',
          value: 'eq'
        }, {
          label: 'is not',
          value: 'ne'
        }]
      }
    },
    'conversation.priority': {
      boolean: {
        comparison: [{
          label: 'is true',
          value: 'true'
        }, {
          label: 'is false',
          value: 'false'
        }]
      }
    },
    'conversation.custom_attribute.brand': {
      optionalSelect: {
        comparison: [{
          label: 'is',
          value: 'eq'
        }, {
          label: 'is not',
          value: 'ne'
        }]
      }
    }
  }
};
let mergedOptions = Object.assign({}, DefaultPredicateComparisonOptions, CustomComparisonOptions);
export default mergedOptions;